(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vo-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vo-slideshow')) {
    customElements.define(
      'vo-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.vo-slideshow__slide')];
          this.dots = [...this.querySelectorAll('.vo-slideshow__dot')];
          this.index = 0;
          this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.index), true)));
          const seconds = Number(this.dataset.autoplay);
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.slides.length > 1 && seconds > 0 && !reduced) {
            this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
          }
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        go(next, manual) {
          if (manual) clearInterval(this.timer);
          this.index = (next + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === this.index);
            slide.toggleAttribute('aria-hidden', i !== this.index);
          });
          this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vo-withdraw"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const form = document.querySelector('[data-vo-withdraw]');
    if (!form) return;
    const KEY = 'vo-withdraw';
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    const fields = () => [...form.querySelectorAll('[data-label]')].filter((f) => f.value.trim());
    const rows = (pairs) => pairs.map(([k, v]) => `<dt>${esc(k)}</dt><dd>${esc(v)}</dd>`).join('');

    const done = form.querySelector('[data-vo-withdraw-done]');
    if (done) {
      let data = null;
      try { data = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
      const pairs = data ? data.pairs : [];
      done.querySelector('[data-vo-withdraw-summary]').innerHTML = rows(pairs);
      done.scrollIntoView({ block: 'center' });
      done.focus({ preventScroll: true });
      done.querySelector('[data-vo-withdraw-print]').addEventListener('click', () => window.print());
      done.querySelector('[data-vo-withdraw-download]').addEventListener('click', () => {
        const text = ['Confirmation of withdrawal', `${form.dataset.shop} (${form.dataset.shopUrl})`, '']
          .concat(pairs.map(([k, v]) => `${k}: ${v}`))
          .concat(['', 'We have received your withdrawal. Keep this confirmation for your records.'])
          .join('\n');
        const a = document.createElement('a');
        a.href = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
        a.download = 'withdrawal-confirmation.txt';
        a.click();
        URL.revokeObjectURL(a.href);
      });
      return;
    }

    const show = (n) => {
      form.querySelectorAll('[data-vo-withdraw-panel]').forEach((p) => (p.hidden = p.dataset.voWithdrawPanel !== String(n)));
      form.querySelector(`[data-vo-withdraw-panel="${n}"]`).scrollIntoView({ block: 'nearest' });
    };
    form.querySelector('[data-vo-withdraw-next]').addEventListener('click', () => {
      const required = [...form.querySelectorAll('[data-vo-withdraw-panel="1"] [required]')];
      const invalid = required.filter((f) => !f.checkValidity());
      required.forEach((f) => f.setAttribute('aria-invalid', String(!f.checkValidity())));
      if (invalid.length) { invalid[0].reportValidity(); return; }
      form.querySelector('[data-vo-withdraw-review]').innerHTML = rows(fields().map((f) => [f.dataset.label, f.value.trim()]));
      show(2);
    });
    form.querySelector('[data-vo-withdraw-back]').addEventListener('click', () => show(1));
    form.addEventListener('submit', () => {
      const when = new Date();
      const stamp = when.toLocaleString('en-GB', { dateStyle: 'long', timeStyle: 'short' }) + ' (' + Intl.DateTimeFormat().resolvedOptions().timeZone + ')';
      form.querySelector('[data-vo-withdraw-time]').value = stamp;
      const pairs = [['Submitted', stamp]].concat(fields().map((f) => [f.dataset.label, f.value.trim()]));
      try { sessionStorage.setItem(KEY, JSON.stringify({ pairs })); } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
